<template>
  <div
    style="width: 100%"
    class="mx-2"
  >
    <v-col cols="12">
      <app-title texto="ATUAÇÃO PROFISSIONAL" />
    </v-col>
    <v-col
      v-for="f in filtro"
      :key="f.titulo"
      cols="12"
    >
      <filtro-base :value="f" />
    </v-col>
  </div>
</template>

<script>
import AppTitle from '@/components/core/AppTitle';
import FiltroBase from '@/components/monitoramento/perfil/filtro/base/FiltroBase';
import FiltroPerfil from '@/modules/filtroPerfil';

export default {
  name: 'FiltroAtuacaoProfissional',

  components: { AppTitle, FiltroBase },

  data() {
    return {
      filtro: {
        experiencia: {
          titulo: 'EXPERIÊNCIAS PROFISSIONAIS',
          habilitado: true,
          filhos: [
            {
              id: 'setores',
              tipo: 'select',
              titulo: 'Setores',
              habilitado: false,
              selecionado: [],
              lista: this.$store.state.perfil.listaSetores.filter((c) => !c.isOutro),
              itemText: 'nome',
              icone: 'lan',
              multiplo: true,
              colunas: 6,
              filhos: [
                {
                  id: 'outros',
                  tipo: 'extra',
                  titulo: 'Pesquisar Outro(s)',
                  opcao: false,
                  outros: null,
                },
              ],
            },
            {
              id: 'funcoes',
              tipo: 'select',
              titulo: 'Funções Gratificadas',
              habilitado: false,
              selecionado: [],
              lista: this.$store.state.perfil.listaFuncoes.filter((c) => !c.isOutro),
              itemText: 'nome',
              icone: 'badge',
              multiplo: true,
              todas: true,
              colunas: 6,
              filhos: [
                {
                  id: 'outros',
                  tipo: 'extra',
                  titulo: 'Pesquisar Outro(s)',
                  opcao: false,
                  outros: null,
                },
              ],
            },
            {
              id: 'vinculos',
              tipo: 'select',
              titulo: 'Vínculos',
              habilitado: false,
              selecionado: [],
              lista: this.$store.state.perfil.listaVinculos.filter((c) => !c.isOutro),
              itemText: 'nome',
              icone: 'diversity_3',
              multiplo: true,
              colunas: 6,
              filhos: [
                {
                  id: 'outros',
                  tipo: 'extra',
                  titulo: 'Pesquisar Outro(s)',
                  opcao: false,
                  outros: null,
                },
              ],
            },
            {
              id: 'niveis',
              tipo: 'select',
              titulo: 'Níveis da Gratificação',
              habilitado: false,
              selecionado: [],
              lista: this.$store.state.perfil.listaNiveisGratificacoes.filter((c) => !c.isOutro),
              itemText: 'nome',
              icone: 'workspace_premium',
              multiplo: true,
              colunas: 6,
              filhos: [
                {
                  id: 'outros',
                  tipo: 'extra',
                  titulo: 'Pesquisar Outro(s)',
                  opcao: false,
                  outros: null,
                },
              ],
            },
            {
              id: 'cargos',
              tipo: 'select',
              titulo: 'Cargos',
              habilitado: false,
              selecionado: [],
              lista: this.$store.state.perfil.listaCargos.filter((c) => !c.isOutro),
              itemText: 'nome',
              icone: 'engineering',
              multiplo: true,
              colunas: 6,
              filhos: [
                {
                  id: 'outros',
                  tipo: 'extra',
                  titulo: 'Pesquisar Outro(s)',
                  opcao: false,
                  outros: null,
                },
              ],
            },
            {
              id: 'situacao',
              tipo: 'confirm',
              titulo: 'Situação',
              habilitado: false,
              opcoes: [
                { nome: 'Atual', valor: 'ATUAL' },
                { nome: 'Concluída', valor: 'CONCLUIDA' },
              ],
              opcao: null,
              horizontal: true,
              colunas: 6,
              filhosDependentes: false,
              filhos: [],
            },
            {
              id: 'areasProfissional',
              tipo: 'select',
              titulo: 'Áreas de Atuação Profissional',
              habilitado: false,
              selecionado: [],
              lista: this.$store.state.perfil.listaAreasProfissional.filter((c) => c.id),
              itemText: 'nome',
              icone: 'business_center',
              multiplo: true,
              todas: true,
              colunas: 6,
              filhos: [],
            },
            {
              id: 'tempo',
              tipo: 'time',
              titulo: 'Tempo Total de Experiência (tempo mínimo)',
              habilitado: false,
              anos: 0,
              meses: 0,
              colunas: 6,
              filhos: [],
            },
          ],
        },
      },
    };
  },

  watch: {
    filtro: {
      handler(value) {
        const filtroSetores = FiltroPerfil.get('setores', value.experiencia.filhos);
        const filtroSetoresOutros = FiltroPerfil.get('outros', filtroSetores.filhos);
        const filtroFuncoes = FiltroPerfil.get('funcoes', value.experiencia.filhos);
        const filtroFuncoesOutros = FiltroPerfil.get('outros', filtroFuncoes.filhos);
        const filtroVinculos = FiltroPerfil.get('vinculos', value.experiencia.filhos);
        const filtroVinculosOutros = FiltroPerfil.get('outros', filtroVinculos.filhos);
        const filtroNivel = FiltroPerfil.get('niveis', value.experiencia.filhos);
        const filtroNivelOutros = FiltroPerfil.get('outros', filtroNivel.filhos);
        const filtroCargos = FiltroPerfil.get('cargos', value.experiencia.filhos);
        const filtroCargosOutros = FiltroPerfil.get('outros', filtroCargos.filhos);
        const filtroSituacao = FiltroPerfil.get('situacao', value.experiencia.filhos);
        const filtroAreasProfissional = FiltroPerfil.get('areasProfissional', value.experiencia.filhos);
        const filtroTempo = FiltroPerfil.get('tempo', value.experiencia.filhos);

        const retorno = {
          setores: {
            ...FiltroPerfil.getRetorno(filtroSetores),
            outros: FiltroPerfil.getRetorno(filtroSetoresOutros),
          },
          funcoes: {
            ...FiltroPerfil.getRetorno(filtroFuncoes),
            outros: FiltroPerfil.getRetorno(filtroFuncoesOutros),
          },
          vinculos: {
            ...FiltroPerfil.getRetorno(filtroVinculos),
            outros: FiltroPerfil.getRetorno(filtroVinculosOutros),
          },
          niveis: {
            ...FiltroPerfil.getRetorno(filtroNivel),
            outros: FiltroPerfil.getRetorno(filtroNivelOutros),
          },
          cargos: {
            ...FiltroPerfil.getRetorno(filtroCargos),
            outros: FiltroPerfil.getRetorno(filtroCargosOutros),
          },
          situacao: FiltroPerfil.getRetorno(filtroSituacao),
          areasProfissional: FiltroPerfil.getRetorno(filtroAreasProfissional),
          tempo: FiltroPerfil.getRetorno(filtroTempo),
        };
        retorno.habilitado = FiltroPerfil.getHabilitado(retorno);
        this.$emit('return', retorno.habilitado ? retorno : null);
      },
      deep: true,
    },
  },
};
</script>
